export const CONTACT_EMAIL = "tu-correo@ejemplo.com";

export const TIMELINE = [
  {
    id: "2006",
    year: "2006",
    place: "Pizzería",
    title: "Una pizzería con vitrinas",
    body: "Todo empezó con una pizzería cuya temática era mostrar mi pequeña colección. En ese momento no imaginaba un museo: era un restaurante de pizzas con vitrinas y pósters llenos de figuras de las Tortugas Ninja.",
    photos: [{ src: "/proyecto/2006-pizzeria.jpg", caption: "Abril 2006 · La pizzería" }],
  },
  {
    id: "2018",
    year: "2018",
    place: "Tijuana",
    title: "La primera idea de un museo",
    body: "En Tijuana tuve por primera vez la idea de un museo. En una hoja de cuaderno de rayas dibujé a mano la fachada: un muro con un acceso en forma de arco circular donde estaría la puerta. También tracé el layout de un plano arquitectónico sobre un espacio cuadrado, distinto al espacio horizontal de este recorrido.",
    photos: [{ src: "/proyecto/2018-bocetos.jpg", caption: "2018 · Bocetos de la fachada y el plano" }],
  },
  {
    id: "2023",
    year: "2023",
    place: "La colección",
    title: "Parte de la colección",
    body: "Figuras, juguetes, cómics y cajas que fueron creciendo con los años hasta llenar un cuarto entero.",
    photos: [{ src: "/proyecto/2023-octubre.jpg", caption: "Octubre 2023 · Parte de la colección" }],
  },
  {
    id: "2024-01",
    year: "Enero 2024",
    place: "Culiacán, Sinaloa",
    title: "La venta que no fue",
    body: "Reuní todos los juguetes, cómics, revistas y artículos para buscarles un nuevo hogar con un comprador. Mientras publicaba en redes sociales, reflexioné y cancelé la venta: mejor buscar la manera de abrir un museo al público, no como negocio sino como una sociedad civil, cubriendo solo los gastos operativos. Esta vez lo imaginé en mi tierra natal, Culiacán, Sinaloa.",
    photos: [{ src: "/proyecto/2023-coleccion.jpg", caption: "Diciembre 2023 · Reuniendo la colección" }],
    tasks: ["Bocetos", "Registro de marca", "Trámites de sociedad civil", "Notarios para el acta constitutiva", "Digitalización de piezas"],
  },
  {
    id: "2024-10",
    year: "Octubre 2024",
    place: "Centro de Culiacán",
    title: "El local perfecto",
    body: "Encontré un local ideal para rentar en el centro de la ciudad. Pero los efectos del llamado Culiacanazo 2 lo complicaron todo: las empresas de transporte se negaban a entrar a la ciudad para traer la colección desde el norte y, hacia fin de año, la situación económica y social era un caos, con negocios del centro cerrando sus puertas por la violencia.",
    photos: [
      { src: "/proyecto/2024-local.jpg", caption: "Octubre 2024 · El local en el centro de Culiacán" },
    ],
  },
  {
    id: "2024-11",
    year: "Noviembre 2024",
    place: "Empacando",
    title: "La colección en cajas",
    body: "Empaqué los juguetes en cajas, cada una con su etiqueta y código QR para saber qué hay dentro.",
    photos: [{ src: "/proyecto/2024-cajas.jpg", caption: "Noviembre 2024 · Empacando juguetes" }],
  },
  {
    id: "2025-01",
    year: "Enero 2025",
    place: "Culiacán",
    title: "Una pausa obligada",
    body: "Cancelé el trato con el propietario del local, con la promesa de que, si seguía desocupado, podrían volver a considerarme.",
  },
  {
    id: "2025-03",
    year: "3 de marzo de 2025",
    place: "IMPI",
    title: "MUTONI® es una marca registrada",
    body: "Obtuve el registro de la marca MUTONI ante el Instituto Mexicano de la Propiedad Industrial.",
    badge: "Registro No. 3250845",
    link: "https://marcia.impi.gob.mx/marcas/search/details/RM202403250845",
  },
  {
    id: "2025",
    year: "2025",
    place: "Salud primero",
    title: "Cambio de prioridades",
    body: "El resto del año mi prioridad cambió: comencé los procesos quirúrgicos para reemplazar ambas caderas, un efecto secundario de los tratamientos contra el cáncer que recibí en 2013 y 2014. El proyecto del museo quedó a un lado.",
    photos: [
      { src: "/proyecto/2025-hospital.jpg", caption: "2025 · En el hospital, con Donatello" },
      { src: "/proyecto/2025-recuperacion.jpg", caption: "2025 · Recuperación después de la cirugía" },
    ],
  },
  {
    id: "2026",
    year: "2026",
    place: "Hoy",
    title: "Un museo digital",
    body: "Sigo teniendo el deseo, aunque hoy lo veo difícil. Por eso nació este proyecto digital: para que cualquiera pueda recorrer el museo que imaginé, sala por sala.",
    current: true,
    photos: [
      { src: "/proyecto/2026-recorrido.jpg", caption: "2026 · El recorrido digital de MUTONI" },
      { src: "/proyecto/2026-angel.jpg", caption: "2026 · Ángel L.", position: "center 45%" },
    ],
  },
];
